import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import {compose} from 'redux';
import colors from '../../util/colors';
import * as fonts from '../../util/fonts';
import {Icons} from '../../util/icons';
import Header1 from '../headers/header1';
import Icon from '../icon';
import {Column, Row} from '../layout';
import './styles.scss';

interface ModalTemplateProps {
  type?: 'error' | 'success';
  inputType?: 'confirm' | 'option' | 'noInput';
  size?: 'sm' | 'lg' | 'xl';
  children: any;
  show: boolean;
  onHide(): void;
  cross?: boolean;
  onSubmit?(): void;
  onCancel?(): void;
  hideFooter?: boolean;
  title?: string;
  subTitle?: string;
  className?: string;
  contentClassName?: string;
  buStyles: any;
  centered?: boolean;
  titleStyle?: any;
  lockClickOutside?: boolean;
}

function ModalTemplate({
  type,
  children,
  show,
  onHide,
  cross = false,
  onSubmit,
  onCancel,
  hideFooter = false,
  title,
  subTitle,
  inputType = 'confirm',
  size,
  className,
  titleStyle,
  contentClassName,
  buStyles,
  lockClickOutside,
  centered = true,
}: ModalTemplateProps) {
  let icon: any;
  let classIcon: any;
  let classCross: any;

  switch (type) {
    case 'error': {
      icon = Icons.ALERT_PROBLEM;
      classIcon = 'modal-header-icon-error';
      break;
    }
    case 'success': {
      icon = Icons.SUCCESS;
      classIcon = 'modal-header-icon';
      break;
    }
    default: {
      break;
    }
  }

  const renderFooter = () => {
    switch (inputType) {
      case 'confirm':
        return (
          <Modal.Footer
            className="modal-footer"
            onClick={() => {
              if (onSubmit) {
                onSubmit();
              }
              onHide();
            }}>
            Ok
          </Modal.Footer>
        );
      case 'option':
        return (
          <Modal.Footer className="modal-footer-option">
            <Row className="modal-option-row">
              <Column
                className="modal-option-column"
                onClick={() => {
                  if (onSubmit) {
                    onSubmit();
                  }
                  onHide();
                }}>
                Sim
              </Column>
              <div className="vertical-row"></div>
              <Column
                className="modal-option-column"
                onClick={() => {
                  if (onCancel) {
                    onCancel();
                  }
                  onHide();
                }}>
                Não
              </Column>
            </Row>
          </Modal.Footer>
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      show={show}
      centered={centered}
      onHide={lockClickOutside ? () => {} : onHide}
      className={className}
      contentClassName={contentClassName}
      size={size}>
      <Column className="modal-container">
        <div
          style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          {(title || subTitle) && (
            <Row className="modal-container-header-title">
              <Column>
                {title && (
                  <Header1 className="title-header-modal" style={titleStyle}>
                    {title}
                  </Header1>
                )}
              </Column>
            </Row>
          )}
          <Icon
            className="modal-cross-close svg-close-button custom-close-button"
            name={Icons.CLOSE}
            width={'26'}
            height={'26'}
            changeViewbox={true}
            strokeWidth={'0.5'}
            onClick={onHide}
            display={cross ? '' : 'none'}
            color={buStyles?.primaryColor || colors.blue}
          />
        </div>
        {classIcon && (
          <Row>
            <Icon
              className={classIcon}
              name={icon}
              width={'28'}
              height={'28'}
            />
          </Row>
        )}
        <div
          style={{
            ...fonts.M,
            color: colors.black,
            display: 'flex',
            justifyContent: 'center',
          }}>
          {subTitle}
        </div>
        <Column className="modal-container-information">{children}</Column>
      </Column>
      {!hideFooter && renderFooter()}
    </Modal>
  );
}

ModalTemplate.defaultProps = {
  titleStyle: {color: colors.black, fontWeight: 'bold'},
};

const mapStateToProps = ({globalStyles}: any) => ({
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(ModalTemplate));
